import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Button, Stack, Typography } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import BenefitHint from '../../component/benefitTabs/BenefitHint';
import { BenefitPaper } from '../../component/benefitTabs/BenefitPaper';
import { getBenefitIcon } from '../../module/benefits/BenefitIcon';
import BenefitSubPage from '../../module/benefits/BenefitSubPage';
import { CarLinks } from '../../module/benefits/car/links';
import { AuthorizedLayout } from '../../module/navigation/AuthorizedLayout';

export const CarLearnMorePage: React.FC = () => {
  const { t } = useTranslation('benefitsModule');
  return (
    <AuthorizedLayout title={t('CAR.settings.title')} breadcrumbs={[{ title: t('CAR.title'), to: '/benefits/car/settings' }]}>
      <BenefitSubPage icon={getBenefitIcon(BenefitDTOBenefitEnum.Car)} title={t('CAR.title')} subTitle={t('CAR.settings.title')}>
        <BenefitPaper sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <Stack
            spacing={4}
            sx={{
              alignSelf: 'center',
              width: '60%',
            }}
          >
            <Stack>
              <Typography variant="h1" gutterBottom>
                {t('CAR.learnMore.title')}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: 'text.secondary',
                }}
              >
                {t('CAR.learnMore.description')}
              </Typography>
            </Stack>
            <CarLearnMoreList />
            <BenefitHint
              title={t('CAR.hint.customer.title')}
              description={
                <Stack spacing={1}>
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'text.secondary',
                    }}
                  >
                    {t('CAR.hint.customer.description')}
                  </Typography>
                  <Button
                    variant="contained"
                    size="small"
                    href={CarLinks.REGISTER_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ width: 'fit-content' }}
                  >
                    {t('CAR.hint.customer.button')}
                  </Button>
                </Stack>
              }
            />
            <BenefitHint
              title={t('CAR.hint.faq.title')}
              description={
                <Typography
                  variant="body2"
                  sx={{
                    color: 'text.secondary',
                  }}
                >
                  <Trans
                    i18nKey="benefitsModule:CAR.hint.faq.description"
                    components={{
                      email: <a href={CarLinks.MAIL} />,
                      site: <a href={CarLinks.SITE} target="_blank" rel="noopener noreferrer" />,
                      faq: <a href={CarLinks.FAQ} target="_blank" rel="noopener noreferrer" />,
                    }}
                  />
                </Typography>
              }
            />
          </Stack>
        </BenefitPaper>
      </BenefitSubPage>
    </AuthorizedLayout>
  );
};

export default CarLearnMorePage;

const CarLearnMoreList = () => {
  const { t } = useTranslation('benefitsModule');
  const listKeys = ['save', 'convert', 'select', 'reserve', 'time', 'include', 'package', 'part'] as const;

  return (
    <Stack spacing={2} sx={{ mb: 4 }}>
      {listKeys.map((key, idx) => (
        <Stack
          key={`${key}-${idx}`}
          direction="row"
          spacing={2}
          sx={{
            alignItems: 'center',
          }}
        >
          <CheckCircleIcon
            sx={{
              width: 32,
              height: 32,
            }}
            color="success"
            fontSize="small"
          />

          <Typography
            variant="body1"
            sx={{
              fontWeight: 500,
            }}
          >
            {t(`CAR.learnMore.${key}`)}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};
